/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'extension.charts.aggregateData': 'Samlede data',
  'extension.charts.aggregateDataDescription':
    'Kombiner verdier til ett enkelt datapunkt når flere rader har samme verdi.',
  'extension.charts.category': 'Kategori',
  'extension.charts.customizeTab': 'Tilpass',
  'extension.charts.dataMissing.details': 'Vi finner ikke dette diagrammets kildetabell på siden.',
  'extension.charts.dataMissing.title': 'Ingen data å vise',
  'extension.charts.dataTab': 'Data',
  'extension.charts.defaultColumnName': 'Kolonne {0}',
  'extension.charts.defaultTitle': 'Diagram uten tittel',
  'extension.charts.defaultYLabel': 'Akse uten navn',
  'extension.charts.extensionTitle': 'Diagram',
  'extension.charts.height': 'Diagramhøyde',
  'extension.charts.height.large': 'Høyere',
  'extension.charts.height.medium': 'Standard',
  'extension.charts.height.small': 'Lavere',
  'extension.charts.horizontal.orientation.label': 'Horisontalt',
  'extension.charts.insert.tooltip': 'Sett inn diagram',
  'extension.charts.legend': 'Forklaring',
  'extension.charts.legend.auto': 'Automatisk',
  'extension.charts.legend.bottom': 'Nederst',
  'extension.charts.legend.left': 'Venstre',
  'extension.charts.legend.position': 'Plassering av forklaring',
  'extension.charts.legend.right': 'Høyre',
  'extension.charts.legend.show': 'Vis forklaring',
  'extension.charts.legend.top': 'Øverst',
  'extension.charts.options.label': 'Diagramalternativer',
  'extension.charts.options.tooltip': 'Endre diagamalternativer',
  'extension.charts.orientation.label': 'Retning',
  'extension.charts.seriesNames': 'Dataserie',
  'extension.charts.showPoints': 'Vis datapunkter',
  'extension.charts.smoothLines': 'Glatte linjer',
  'extension.charts.style': 'Stil',
  'extension.charts.title': 'Tittel',
  'extension.charts.type.bar': 'Stolpediagram',
  'extension.charts.type.fieldDescription': 'Type diagram',
  'extension.charts.type.line': 'Linjediagram',
  'extension.charts.type.pie': 'Sektordiagram',
  'extension.charts.userTitle': 'Tittel',
  'extension.charts.vertical.orientation.label': 'Vertikalt',
  'extension.charts.xAxis': 'X-akse',
  'extension.charts.xLabel': 'Etikett for X-akse',
  'extension.charts.yLabel': 'Etikett for Y-akse',
};
